import React from "react";
import usePriceDetailsService from "./service";
import { PriceDetailsPropTypes } from "./types";
import { useCopies } from "shared/hooks/useCopies";
import { getFormattedCurrency } from "shared/utils";

function PriceDetails(props: PriceDetailsPropTypes) {
  const copies = useCopies();
  const service = usePriceDetailsService(props);

  return (
    <React.Fragment>
      {service.isFreeTicket ? (
        <strong className="ticketCard_footerPriceWrapper--priceFree">{copies.get("free.uppercase")}</strong>
      ) : (
        props.applicableRate && (
          <React.Fragment>
            <strong className="ticketCard_footerPriceWrapper--priceToPay">
              {getFormattedCurrency(props.applicableRate?.applicablePrice, props.localeId)}
              {service.isDiscountedTicket && (
                <span className="ticketCard_footerPriceWrapper--priceDiscount">
                  {copies.get("price.discount.percentage", { 0: props.applicableRate?.discountPercentage })}
                </span>
              )}
            </strong>
            {service.isDiscountedTicket && (
              <strong className="ticketCard_footerPriceWrapper--priceAmount">
                {getFormattedCurrency(props.applicableRate?.basePrice, props.localeId)}
              </strong>
            )}
          </React.Fragment>
        )
      )}
    </React.Fragment>
  );
}

export default PriceDetails;
